export default __webpack_public_path__ + "static/media/Nunito-Regular.b84ef150.woff";